import React from "react";

const PanelGridComponent = (props) => {
    const { Renderer } = props;

    return <Renderer {...props} />;
};

export default PanelGridComponent;
